import Vue from 'vue'
Vue.directive('preventReClick', {
	inserted (el, binding) {
	  el.addEventListener('click', () => {
		if (!el.disabled) {
		  el.disabled = true
		  setTimeout(() => {
			el.disabled = false
		  },binding.value || 1000)
		}
	  })
	}
  });
const pointDoms = [];
Vue.directive('preventReClickTag', {
	inserted (el, binding) {
	  pointDoms.push(el);
      el.addEventListener('click', () => {
          pointDoms.forEach(pointItem => {
              pointItem.style.pointerEvents = 'none';
          });
          setTimeout(() => {
              pointDoms.forEach(pointItem => {
                  pointItem.style.pointerEvents = 'auto';
              });
          }, binding.value || 1000);
      });
	}
  });
  Vue.directive('focus', {
  	inserted (el, binding) {
  	  el.querySelector("input").focus();
  	}
  });
  Vue.directive('resize', {
	bind(el, binding) {
	  // el为绑定的元素，binding为绑定给指令的对象
	  let width = '', height = '';
  
	  function isReize() {
		const style = document.defaultView.getComputedStyle(el);
		if (width !== style.width || height !== style.height) {
		  // 关键(这传入的是函数,所以执行此函数)
		  binding.value({ width: style.width, height: style.height });
		}
		width = style.width;
		height = style.height;
	  }
  
	  el.__vueSetInterval__ = setInterval(isReize, 300);
	},
  
	unbind(el) {
	  clearInterval(el.__vueSetInterval__);
	}
  });



// WEBPACK FOOTER //
// ./src/api/preventReClick.js